<template>
  <div v-if="pidShowId === '基础模版'">
    <basisModel />
  </div>
  <!-- 211:第一期。221:第二期。222:第三期。223:第四期 -->
  <div
    v-if="
      pidShowId === '211' ||
      pidShowId === '221' ||
      pidShowId == '222' ||
      pidShowId == '223'
    "
  >
    <phaseOneModel />
  </div>
  <!-- <div v-if="pidShowId === '221'">
    <phaseOneModel />
  </div> -->
  <div class="clearfix" v-if="pidShowId === '215'">
    <coverModel />
  </div>
</template>

<script setup>
import basisModel from "./basisModel/index.vue"; //基础的模版
import phaseOneModel from "./phaseOne/index"; //第一期模版211
import coverModel from "./coverModel/index.vue"; //封面215
import {
  ref,
  onMounted,
  nextTick,
  getCurrentInstance,
  watch,
  onBeforeMount,
  onUnmounted,
} from "vue";
import { useRouter, useRoute, onBeforeRouteUpdate } from "vue-router";
import useDataInfo from "../store/index";
const pidShowId = ref();
const route = useRoute();
const dataInfo = useDataInfo();
onBeforeMount(async () => {
  if (
    route.query.pid &&
    (route.query.pid === "211" ||
      route.query.pid === "215" ||
      route.query.pid === "221" ||
      route.query.pid === "222" ||
      route.query.pid === "223")
  ) {
    pidShowId.value = route.query.pid;
    if (
      pidShowId.value == "211" ||
      route.query.pid === "215" ||
      route.query.pid === "221" ||
      route.query.pid === "222" ||
      route.query.pid === "223"
    ) {
      await dataInfo.navListInfo(route.query.pid ? route.query.pid : 0);
      dataInfo.listInfo("", 1, 0, route.query.pid);
    }
    // switch (pidShowId.value) {
    //   case "211":
    //     await dataInfo.navListInfo(route.query.pid ? route.query.pid : 0);
    //     dataInfo.listInfo("", 1, 0, route.query.pid);
    //     break;
    //   case "221":
    //     await dataInfo.navListInfo(route.query.pid ? route.query.pid : 0);
    //     dataInfo.listInfo("", 1, 0, route.query.pid);
    //     break;
    //   case "223":
    //     break;
    // }
  } else {
    pidShowId.value = "基础模版";
  }
});
onUnmounted(() => {
  sessionStorage.removeItem("WXTabsIndex");
  // sessionStorage.removeItem("");
});
</script>
<style lang="less" scoped>
.clearfix::before,
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}
</style>
